import React from "react";
import Login from "../Login";

const LoginView = ({ onLogin, isLoading }) => {
  return <Login onLogin={onLogin} isLoading={isLoading} />;
};

export default LoginView;
